module.exports = __webpack_public_path__ + "balanced-portfolio-strategic-bets-policy.3d15382808e3a7a7c9d21cb907c64e6d.svg";